module.exports = __webpack_public_path__ + "img/custom1.d5f9672c.svg";